export default {
  category: "Category",
  submit: "Add category"
};



// WEBPACK FOOTER //
// ./src/components/forms/task-form/TaskForm.messages.js